import { restClient } from 'libs/restClient';
import { formatDate, addDays } from 'helpers/DateHelper';
import {
  FETCH_DEVICE_LIST,
  CLEAR_DEVICE_LIST,
  SET_DEVICE_LIST_SEARCH_TERM
} from 'actions/types';

export function fetchDeviceList({
  searchTerm = '',
  dateFrom,
  dateTo,
  showFiltered
}) {
  const startDate = formatDate(dateFrom);

  // coldfusion issue, have to add 2 extra day
  const finishDate = formatDate(addDays(dateTo, 2));

  const url = `/certifieddevicemodels?page=0&all=${!showFiltered}&where=%28name LIKE '%25${searchTerm}%25' OR modelnumber LIKE '%25${searchTerm}%25'%29 AND completedat >= '${startDate}' AND completedat < '${finishDate}'`;
  const payload = restClient.get(url);
  return {
    type: FETCH_DEVICE_LIST,
    payload
  };
}

export function clearDeviceList() {
  return { type: CLEAR_DEVICE_LIST };
}

export function setSearchTerm(term) {
  return {
    type: SET_DEVICE_LIST_SEARCH_TERM,
    payload: { term }
  };
}



// WEBPACK FOOTER //
// ./src/actions/devices.js